import { render, staticRenderFns } from "./SaleSearch.vue?vue&type=template&id=4ac4a0e2"
import script from "./SaleSearch.vue?vue&type=script&lang=ts"
export * from "./SaleSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac4a0e2')) {
      api.createRecord('4ac4a0e2', component.options)
    } else {
      api.reload('4ac4a0e2', component.options)
    }
    module.hot.accept("./SaleSearch.vue?vue&type=template&id=4ac4a0e2", function () {
      api.rerender('4ac4a0e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleSearch.vue"
export default component.exports